import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import Button from '@components/Button'
import Checkbox from '@components/Checkbox'
import Tooltip from '@components/Tooltip/Tooltip'
import InfoBox from '@components/InfoBox'
import WarningIcon from '@components/Icon/Warning'
import { projectApi } from '@atheneum/api'
import InfoIcon from '@components/icons/Info'
import { TagsInput } from '@components/Autocomplete'
class ClosingNote extends Component {
  static propTypes = {
    modalStore: PropTypes.object.isRequired,
    projectStore: PropTypes.object.isRequired,
    eplStore: PropTypes.object.isRequired,
    caseCodeRequired: PropTypes.bool,
    staticData: PropTypes.object
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: true
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      closingNote: '',
      isSubmitting: false,
      skipFeedback: false,
      sendRejectionEmails: true,
      willHaveUnresolvedEpls: false,
      clientContacts: [],
      clientContactOptions: [],
      isFormValidated: true,
      selectAllClientContacts: false,
    })
    projectApi.getUnresolvedEpls(this.props.projectStore.id).then(res => {
      this.willHaveUnresolvedEpls = res.willHaveUnresolvedEpls
    })

    // NOTE: hardcoded skip feedback for bain & company
    if (this.props.projectStore.project.parentAccountId === 14) {
      this.skipFeedback = true
    }

    if (this.skipFeedback === false) {
      projectApi.getProjectClients(this.props.projectStore.project.id).then((results) => {
        this.clientContactOptions = results
        this.clientContacts = results.slice()
      })
    }

    this.updateSelectAllClientContactsState()
  }

  updateSelectAllClientContactsState = () => {
    if (this.clientContacts.length !== this.clientContactOptions.length) {
      this.selectAllClientContacts = false
    } else if (this.clientContacts.length === this.clientContactOptions.length) {
      this.selectAllClientContacts = true
    }
  }

  updateFormValidatedState = () => {
    // must select at least one client contact for feedback
    this.isFormValidated = this.clientContacts.length >= 1 || this.skipFeedback
  }

  renderEmailToolTipContent = () => {
    return (
    <div>
      <span>Send email to experts for:</span><br></br>
      <span>EPL status = Requested, Submitted, For manager approval, Rejected, Not approved, 
            Not available, Recruitment, Not interviewed</span><br></br>
      <span>Reply Status = Applied, Confirmed, Interested</span>
    </div>)
  }

  closeProject = () => {
    const { PROJECT_STATUSES } = this.props.staticData.CONST
    this.isSubmitting = true

    this.updateFormValidatedState()

    if (!this.isFormValidated) {
      return
    }

    const sendData = {
      projectStatusId: PROJECT_STATUSES.CLOSED,
      closingNote: this.closingNote,
      skipFeedback: this.skipFeedback,
      sendRejectionEmails: this.sendRejectionEmails
    }

    if (!this.skipFeedback) {
      sendData.clientContactIds = this.clientContacts.map(contact => contact.id)
    }

    this.props.projectStore
      .sendStatusToServer(sendData)
      .then(() => this.props.modalStore.close())
      .then(() => (this.isSubmitting = false))
      .catch(() => (this.isSubmitting = false))
  }

  render () {
    const wrapperClasses = classNames({
      'expert-form__input-wrapper': true
    })
    const { caseCodeRequired } = this.props
    return (
      <div className="expert-form">
        {this.willHaveUnresolvedEpls && (
          <InfoBox theme="yellow" className="m-b-lg" icon={<WarningIcon />}>
            <span>
              Project still has EPL's in status scheduled. You should update
              them before closing.
              <span
                onClick={() => {
                  this.props.eplStore.setStatus = true
                  this.props.modalStore.close()
                }}>
                <Link
                  to={this.props.projectStore.project.id + '/experts-pipeline'}>
                  show
                </Link>
              </span>
            </span>
          </InfoBox>
        )}
        {caseCodeRequired && (
          <InfoBox theme="yellow" className="m-b-lg" icon={<WarningIcon />}>
            <span>
              Please check if correct case code is given to the Project.
            </span>
          </InfoBox>
        )}
        <h1 className="expert-form__title">Project closing comment</h1>
        <div className="expert-form__input-group">
          <label className="expert-form__label">Add closing comment *</label>
          <div className={wrapperClasses}>
            <div>
              <textarea
                onChange={e => (this.closingNote = e.target.value)}
                value={this.closingNote}
                className="expert-form__input"
                type="textarea"
                rows="5"
              />
            </div>
          </div>
        </div>
        {!this.skipFeedback && (
        <div className="expert-form__input-group">
            <label className="expert-form__label">Client contacts *</label>
          <div className={wrapperClasses}>
            <TagsInput
              value={this.clientContacts}
              itemToString={item => item && item.fullName}
              options={this.clientContactOptions}
              onChange={contacts => {
                this.clientContacts = contacts

                this.updateFormValidatedState()
                this.updateSelectAllClientContactsState()
              }}
            />
            {!this.isFormValidated && (
              <InfoBox theme="red" className="m-b-lg" icon={<WarningIcon />}>
                <span>
                  Please select at least one client contact for feedback
                </span>
              </InfoBox>
            )}
            <Checkbox
              value={this.selectAllClientContacts}
              label="Select all client contacts"
              onChange={val => {
                if (val) {
                  this.clientContacts = this.clientContactOptions.slice()
                } else {
                  this.clientContacts = this.clientContactOptions.slice(0, 1)
                }
                this.updateFormValidatedState()
                this.selectAllClientContacts = val
              }}
            />
          </div>
        </div>
        )}
        <div className="expert-form__input-group">
          <label className="expert-form__label"></label>
          <div className={wrapperClasses}>
            <Checkbox
              value={this.sendRejectionEmails}
              label="Send Participation emails to experts"
              onChange={val => {
                this.sendRejectionEmails = val
              }}
            />
            <div className="inline m-l-lg">
            <Tooltip tooltip={this.renderEmailToolTipContent()}
            placement='bottom'>
              <div className='icon-wrapper'>
                <InfoIcon />
              </div>
            </Tooltip>
            </div>
          </div>
        </div>
        <div className="expert-form__section p-b-0">
          <Tooltip
            className="m-r-lg"
            delay={1}
            placement="bottom"
            tooltip={
              <div className="closing-note__close-effects-note">
                {this.closingNote ? (
                  <div>
                    Close this project. This will:
                    <ul>
                      <li>Update projects end date</li>
                      <li>Disable projects quick logins</li>
                      {this.skipFeedback ? (
                        <li>Email for client feedback will not be sent</li>
                      ) : (
                        <li>Send email to clients to provide feedback</li>
                      )}
                    </ul>
                  </div>
                ) : (
                  'You need to add closing comment to close project'
                )}
              </div>
            }>
            <div className="iconWrapper">
              <Button
                primary
                submit
                onClick={() => this.closeProject()}
                disabled={!this.closingNote || this.isSubmitting || !this.isFormValidated}>
                Save and close project
              </Button>
            </div>
          </Tooltip>
          <div className="inline m-l-lg">
            <Button onClick={this.props.modalStore.close}>Cancel</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default inject(
  'modalStore',
  'staticData',
  'eplStore'
)(observer(ClosingNote))
